import React from "react";
import {
  ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, ReferenceLine, CartesianGrid,
  ComposedChart, Bar, Cell
} from "recharts";
import { RSI_OVERBOUGHT, RSI_OVERSOLD } from "@/lib/constants";

const CHART_MARGIN = { top: 5, right: 8, left: -20, bottom: 0 };
const AXIS_TICK = { fill: "#555", fontSize: 10 };
const PRICE_DOMAIN = ["dataMin", "dataMax"];
const RSI_DOMAIN = [0, 100];
const TOOLTIP_STYLE = {
  background: "#0f0f0f",
  border: "1px solid #222",
  fontSize: 12,
  fontFamily: "JetBrains Mono",
};
const TOOLTIP_LABEL_STYLE = { color: "#8a8a8e" };
const PERIODS = ["1mo", "3mo", "6mo"];

export default function StockCharts({ history, period, onPeriodChange }) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-4">
      <div className="panel p-4">
        <div className="flex items-center justify-between mb-2">
          <div className="micro-label">/ price · {period}</div>
          <div className="flex gap-1">
            {PERIODS.map((p) => {
              const active = period === p;
              const cls = active ? "border-white text-white" : "border-[#222] text-[#8a8a8e] hover:text-white";
              return (
                <button
                  key={p}
                  onClick={() => onPeriodChange(p)}
                  data-testid={`period-${p}`}
                  className={`px-2 py-0.5 text-[10px] font-mono-data border ${cls}`}
                >
                  {p.toUpperCase()}
                </button>
              );
            })}
          </div>
        </div>
        <ResponsiveContainer width="100%" height={250}>
          <LineChart data={history} margin={CHART_MARGIN}>
            <CartesianGrid stroke="#1a1a1a" vertical={false} />
            <XAxis dataKey="date" hide />
            <YAxis tick={AXIS_TICK} domain={PRICE_DOMAIN} />
            <Tooltip contentStyle={TOOLTIP_STYLE} labelStyle={TOOLTIP_LABEL_STYLE} />
            <Line type="monotone" dataKey="close" stroke="#ffffff" dot={false} strokeWidth={1.5} />
          </LineChart>
        </ResponsiveContainer>
      </div>

      <div className="panel p-4">
        <div className="micro-label mb-2">/ rsi & macd hist</div>
        <ResponsiveContainer width="100%" height={120}>
          <LineChart data={history} margin={CHART_MARGIN}>
            <CartesianGrid stroke="#1a1a1a" vertical={false} />
            <XAxis dataKey="date" hide />
            <YAxis tick={AXIS_TICK} domain={RSI_DOMAIN} />
            <ReferenceLine y={RSI_OVERBOUGHT} stroke="#ff3b30" strokeDasharray="2 2" />
            <ReferenceLine y={RSI_OVERSOLD} stroke="#00e676" strokeDasharray="2 2" />
            <Tooltip contentStyle={TOOLTIP_STYLE} />
            <Line type="monotone" dataKey="rsi" stroke="#2979ff" dot={false} strokeWidth={1.2} />
          </LineChart>
        </ResponsiveContainer>
        <ResponsiveContainer width="100%" height={110}>
          <ComposedChart data={history} margin={CHART_MARGIN}>
            <CartesianGrid stroke="#1a1a1a" vertical={false} />
            <XAxis dataKey="date" hide />
            <YAxis tick={AXIS_TICK} />
            <ReferenceLine y={0} stroke="#444" />
            <Tooltip contentStyle={TOOLTIP_STYLE} />
            <Bar dataKey="macd_hist">
              {history.map((d) => (
                <Cell key={d.date} fill={d.macd_hist >= 0 ? "#00e676" : "#ff3b30"} />
              ))}
            </Bar>
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
